import React, {useEffect, useState, useRef} from "react";
import {useBreakpointValue,Box, Container, HStack, Center,Heading,Image,VStack, SimpleGrid, Card, Text, Link,CardHeader, CardBody, LinkBox, LinkOverlay, IconButton, AvatarGroup, Avatar, StepDescription, DarkMode, Divider} from "@chakra-ui/react";

import {useSpring ,animated} from "react-spring"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Popover, PopoverTrigger, PopoverContent, PopoverArrow,PopoverBody } from "@chakra-ui/react";
import digital from "../Assets/certified digital marketing freelancer.png"
import hubspot from "../Assets/HubSpot-Certified-Ben.png"
import BIDA from "../Assets/BIDA-Certified-Ben.png"
import CMSA from "../Assets/CMSA-Certified-Ben.png"
import CBCA from "../Assets/CBCA-Certified-Ben.png"
import experience from "../Assets/work experience.png"
import retail from "../Assets/retail.jpg"
import blockchain from "../Assets/blockchain.jpg"
import financial from "../Assets/financial.jpg"
import estate from "../Assets/Real estate.jpg"
import {IconButton as IconB} from "@mui/material";
import { assets, toolsData } from "../AssetsPort/assets";
import BenAuth from "../Assets/BenAuth.webp"
import { useInView } from "react-intersection-observer"
import { infoList } from "../AssetsPort/assets";
import {motion} from "motion/react"
import "typeface-ovo"






function About({toggleProp, setToggle, setSelected}){


let [info, setInfo] = useState(false)
let [color, setColor] = useState(false)
let [color2, setColor2] = useState(false)
let [color3, setColor3] = useState(false)
let [color4, setColor4] = useState(false)



let onClose =(e)=>{
  setInfo(false)
}

let[visible, setVisible] = useState(false)
let[visible2, setVisible2] = useState(false)



let animation = useSpring ({
  to: {translateY:visible&& 10},
  from: { translateY:visible && 0},
  loop: {reverse: true},
  config: {duration: 1000}
})

let animation2 = useSpring ({
  to: {translateY:visible &&-10},
  from: { translateY:visible && 0},
  loop: {reverse: true},
  config: {duration: 1000}
})


useEffect((e)=>{
setVisible(true)
}, [visible])

  
let {ref: refAbout, inView: inViewAbout} = useInView({triggerOnce: false})

  useEffect((e)=>{
    
    if(inViewAbout){
      setSelected("About")
    }
  }, [inViewAbout])



let mobileView = useBreakpointValue({
  base: true,
  md: false
})


let tabletView = useBreakpointValue({
  md: true, 
  lg: false
})


let nextHub = useBreakpointValue({
   lg:true,
   xl:false
 })



if(mobileView){
  return(
    <div >
       <VStack maxWidth="full" py={10} px={5} alignItems="left" spacing={8} backgroundColor={toggleProp? "#11001f":"gray.100"} color={toggleProp?"white":"gray.700"} id="About">
          
        <Center>
        <VStack>
        <motion.h4 initial={{y: -20, opacity:0}} whileInView={{y:0, opacity: 1}} transition={{duration:0.5, delay: 0.3}} className="text-lg font-ovo">Introduction</motion.h4>
        <div style={{position:"relative"}}>
        <motion.div  initial={{y: -20, opacity:0}} whileInView={{y:0, opacity: 1}} transition={{duration:0.5, delay: 0.5}}>
        {/* <Heading as="h2" size="2xl" id="about" >About Me</Heading> */}
        <h2 id="about" className="font-ovo text-5xl"  style={{position:"relative", zIndex:10}}>About Me</h2>
        
        {/*pointerEvents:"none" because the image is decorative and doesn't need interactivity */}
          <div style={{position:"relative"}}></div>
          <div style={{position:"absolute", top:"0%", right:"-10%", zIndex:0, display:toggleProp? "block":"none", pointerEvents:"none"}}>
          <img src={assets.theme_pattern} className="w-36" />      
          </div>
        </motion.div>
        </div>
        </VStack>
        </Center>

      
        <motion.div initial={{opacity:0}} whileInView={{opacity: 1}} transition={{duration:0.8}} className="flex w-full flex-col lg:flex-row items-center gap-10 ">
        <motion.div initial={{opacity:0, scale:0.9}} whileInView={{scale:1, opacity: 1}} transition={{duration: 0.6}} className="w-64 sm:w-80 rounded-3xl max-w-none">
          <img src={BenAuth} alt="Ben Asenso" className="w-full rounded-3xl" />
        </motion.div>
        
        <Box className="flex-1">
        <motion.div  initial={{opacity:0}} whileInView={{opacity: 1}} transition={{duration: 0.8, delay:1}}>
        <Text fontSize={["lg", "xl"]} textAlign="center" fontWeight="bold" style={{margin: "5px 5px 20px 5px", paddingTop: 20}}>I'm passionate about crafting immersive digital experiences that captivates audiences
        and drive meaningful engagement. With a blend of creativity, technical expertise and a relentless pursuit of innovation, I thrive on pushing the boundaries 
        of what's possible in the ever-evolving world of web development.
        </Text>
        

        <motion.div initial={{opacity:0}} whileInView={{opacity: 1}} transition={{duration: 0.8, delay:1}}>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-2xl  mt-10">
        {infoList.map((f, index)=>{
          return <motion.div key={index} whileHover={{scale: 1.05}} className={`border-[0.5px] border-gray-400 rounded-xl p-6 cursor-pointer  ${toggleProp? "hover:bg-[#11002f]":"hover:bg-[#fcf4ff]"} hover:-translate-y-1 duration-500 
            ${toggleProp? "hover:shadow-[4px_4px_0_#fff]":"hover:shadow-[4px_4px_0_#000]"}`}>
            <Image src={toggleProp? f.iconDark:f.icon} alt={f.title} className="w-7 mt-3"/>
            <h3 className={`my-4 font-semibold ${toggleProp? "text-white":"text-gray-700"}`}>{f.title}</h3>
            <p className={`text-sm ${toggleProp? "text-white/80":"text-gray-600"}`}>{f.description}</p>
          </motion.div>
        })}
        </div>
        </motion.div>

        <motion.h4 initial={{y:20, opacity:0}} whileInView={{y:0, opacity:1}} transition={{duration: 0.5, delay:1.3}} className={`my-6 ${toggleProp? "text-white/80":"text-gray-700"}`}>Tools I use</motion.h4>
        <motion.div initial={{opacity:0}} whileInView={{opacity: 1}} transition={{duration: 1.5, delay: 0.6}} className="flex items-center gap-3 sm:gap-5">
          {toolsData.map((f, index)=>{
            return <motion.div key={index} whileHover={{scale:1.05}} className="flex items-center justify-center w-12 sm:w-14 aspect-square border-[0.5px] border-gray-400 
            rounded-lg cursor-pointer hover:-translate-y-1 duration-500">
              <img src={f} alt="Tool" className="w-5 sm:w-7"/>
            </motion.div>
          })}
        </motion.div>
        </motion.div>
        </Box>
        </motion.div>

        <VStack>
          <Text className="mb-10" color={toggleProp? "white": "gray.700"} fontSize={["md", "lg"]} >
          Fuelled by curiosity for emerging technologies and a commitment to excellence, I'm constantly honing my skills to stay ahead of the curve.
          Whether it's mastering the latest frameworks, delving into data analysis or refining my design aesthetic, I approach every project with enthusiasm and a thirst
          for knowledge.
          But beyond the code, I'm a firm believer in the power of collaboration and communication. I understand that great digital experiences are not just about pixels and
          lines of code, they're about connecting with audiences on a deeper level, understanding their needs and delivering solutions that resonate. <br/><br/>
          When I'm not crafting code or brainstrorming the next big idea, you'll find me exploring the great outdoors, indulging in a good book or seeking inspiration from art and culture.
          I believe that a well-rounded perspective enriches my work and fuels my creativity.
          If you're looking to build a stunning website, optimize your digital presence or embark on a transformative digital journey, I'm here to bring your vision to life. Let's collaborate, innovate and create something extraordinary together.
          </Text>
        </VStack>


               
        <SimpleGrid gridTemplateColumns="1fr" gap={10}>

        <div className="about-skills">
          <div className="skill">
            <p>HTML & CSS</p><Divider className="line" style={{width:"50%", background: !toggleProp? "linear-gradient(264deg, #374151 -5.09%, #000 106.28%)":""}} />
          </div>
          <div className="skill">
            <p>React JS</p><Divider className="line" style={{width:"70%",background: !toggleProp? "linear-gradient(264deg, #374151 -5.09%, #000 106.28%)":""}} />
          </div>
          <div className="skill">
            <p>JavaScript</p><Divider className="line"  style={{width:"60%",background: !toggleProp? "linear-gradient(264deg, #374151 -5.09%, #000 106.28%)":""}} />
          </div>
          <div className="skill">
            <p>Django</p><Divider className="line" style={{width:"50%",background: !toggleProp? "linear-gradient(264deg, #374151 -5.09%, #000 106.28%)":""}} />
          </div>

        </div>

        <div className="about-achievements">
          <div className="achieve">
            <h1 style={{backgroundImage:!toggleProp&& "linear-gradient(270deg, #374151 50.41%, #000 90.25%)", backgroundClip:!toggleProp&&"text"}}>4+</h1>  {/*10+ */} 
            <p className="text-center">YEARS OF EXPERIENCE</p>
          </div>
          <Divider bg={!toggleProp&&"black"} style={{transform:"rotate(90deg)", width:"20%"}}  />
          <div className="achieve">
            <h1 style={{backgroundImage:!toggleProp&& "linear-gradient(270deg, #374151 50.41%, #000 90.25%)", backgroundClip:!toggleProp&&"text"}}>90+</h1>
            <p className="text-center">PROJECTS COMPLETED</p>
          </div>
          <Divider bg={!toggleProp&&"black"} style={{transform:"rotate(90deg)", width:"20%"}}  />
          <div className="achieve">
            <h1 style={{backgroundImage:!toggleProp&& "linear-gradient(270deg, #374151 50.41%, #000 90.25%)", backgroundClip:!toggleProp&&"text"}}>15+</h1>
            <p className="text-center">HAPPY CLIENTS</p>
          </div>

        </div>
        </SimpleGrid>
        

        <Center>
          <VStack>
            <Popover
            isOpen={info}
            onClose={onClose}
            arrowSize={15}
            size="md"
            >
              <PopoverTrigger>
              <IconButton as={IconB} onClick={(e)=> setInfo(true)} children={<FontAwesomeIcon icon={faInfoCircle} size="2xl" />} isRound size="sm" /> 
              </PopoverTrigger>

              <PopoverContent bgColor="purple">
              <PopoverArrow  bgColor="purple" />
                <PopoverBody color="white" align="center" p={4} >
                References and Certification papers can be provided upon request. 
                For authenticity purposes only.
                </PopoverBody>
              </PopoverContent>
            </Popover>

        <Heading mt={5}>Qualifications</Heading>        
        </VStack>

       </Center>  

      
          <VStack px={5}>
        <HStack width={["100%", "80%"]} justifyContent="space-between">
          <VStack>
           <animated.div style={animation}>
          <Image src={digital} loading="lazy" boxSize="80px" alt="certified digital marketing freelancer" />
          </animated.div>
          <Text align="center" fontSize="sm" fontWeight="bold" style={{margin: 5, paddingTop: 20}}>
            Certified Digital<br/> Marketer by Google
          </Text>
          </VStack>

          <VStack>
          <animated.div style={animation2}>
          <Image src={hubspot} width= {20} transform="scale(1.2)" alt="Hubspot Certified (Ben)"/>
          </animated.div>
          <Text align="center" fontSize="sm" fontWeight="bold" style={{margin: 5, paddingTop: 20}}>
            HubSpot Certified
          </Text>
          </VStack>

        </HStack>

        <HStack mt={4} width={["100%", "80%"]} justifyContent="space-between">
          <VStack>
          <animated.div style={animation}>
          <Image src={BIDA} loading="lazy" boxSize="100px" alt="web developer"/>
          </animated.div>
          <Text align="center" fontSize="sm" fontWeight="bold" style={{margin: 5, paddingTop: 20}}>
            BIDA Certified
          </Text>
          </VStack>

          <VStack>
          <animated.div style={animation2}>
          <Image src={CMSA} loading="lazy" boxSize="100px" alt="web developer"/>
          </animated.div>
          <Text align="center" fontSize="sm" fontWeight="bold" style={{margin: 5, paddingTop: 20}}>
            CMSA Certified
          </Text>
          </VStack>
        </HStack>

        <HStack  mt={4} width={["100%", "80%"]}  justifyContent="space-between">
          <VStack>
          <animated.div style={animation}>
          <Image src={CBCA} loading="lazy" boxSize="100px" alt="web developer" />
          </animated.div>
          <Text align="center" fontSize="sm" fontWeight="bold" style={{margin: 5, paddingTop: 20}}>
            CBCA Certified
          </Text>
          </VStack>

          <VStack >
          <animated.div style={animation2}>
          <Image src={experience} loading="lazy" boxSize="80px" alt="work experience"/>
          </animated.div>
          <Text align="center" fontSize="sm" fontWeight="bold" style={{margin: 5, paddingTop: 20}}>
            Years of Relevant Work<br/> Experience
          </Text>
          </VStack>
        </HStack>

        </VStack>

  
    

        
        <Heading mt={5} textAlign="center">Industries</Heading>        

          <Center px={5}>
          <HStack width={["100%", "80%"]}  justifyContent="space-between" >
            <VStack>
            <Avatar src={blockchain} loading="lazy" name="Blockchain" borderWidth={2} _hover={{transform: "scale(1.2)", transition: "transform 0.3s ease-in-out"}} filter={!color && "grayscale(100%)"} boxSize="120px" onMouseEnter={(e)=> setColor(true)} onMouseLeave={(e)=> setColor(false)}/>
            <Text fontSize="xl" fontWeight="bold" style={{margin: 5, paddingTop: 20}}>
            Blockchain
            </Text>
            </VStack>

            <VStack>
            <Avatar src={estate} loading="lazy" name="Real Estate" borderWidth={2} _hover={{transform: "scale(1.2)", transition: "transform 0.3s ease-in-out"}} filter={!color2 && "grayscale(100%)"} boxSize="120px" onMouseEnter={(e)=> setColor2(true)} onMouseLeave={(e)=> setColor2(false)} />
            <Text fontSize="xl" fontWeight="bold" style={{margin: 5, paddingTop: 20}}>
            Real Estate
            </Text>
            </VStack>
          </HStack>
          
          </Center>
      

         
          <Center px={5} paddingBottom={10}>
          <HStack alignItems="start" width={["100%", "80%"]}  justifyContent="space-between" >
            <VStack>
            <Avatar src={financial} loading="lazy" name="financial" borderWidth={2} _hover={{transform: "scale(1.2)", transition: "transform 0.3s ease-in-out"}} filter={!color3 && "grayscale(100%)"} boxSize="120px" onMouseEnter={(e)=> setColor3(true)} onMouseLeave={(e)=> setColor3(false)} />
            <Text fontSize="xl" fontWeight="bold" style={{margin: 5, paddingTop: 20}}>
            Financial <br/> Services
            </Text>
            </VStack>

            <VStack>
            <Avatar src={retail} loading="lazy" name="retail" borderWidth={2} _hover={{transform: "scale(1.2)", transition: "transform 0.3s ease-in-out"}} filter={!color4 && "grayscale(100%)"} boxSize="120px" onMouseEnter={(e)=> setColor4(true)} onMouseLeave={(e)=> setColor4(false)}/>
            <Text fontSize="xl" fontWeight="bold" style={{margin: 5, paddingTop: 20}}>
            Retail
            </Text>
            </VStack>
          </HStack>

          </Center>

          

        
        

        </VStack>   

    </div>
  )
}



else{

  
  return(
    <div>
      <motion.div initial={{opacity:0}} whileInView={{opacity: 1}} transition={{duration: 1}}>
        <VStack maxWidth="full" padding={10} alignItems="left" spacing={8} backgroundColor={toggleProp? "#11001f":"gray.100"} color={toggleProp? "white":"gray.700"} id="About" ref={refAbout}>  
          
        <Center >
        <VStack>
        <motion.h4 initial={{y: -20, opacity:0}} whileInView={{y:0, opacity: 1}} transition={{duration:0.5, delay: 0.3}} className="text-lg font-ovo">Introduction</motion.h4>
        {/* <Heading as="h2" size="2xl" id="about" >About Me</Heading> */}
        <div style={{position:"relative"}}>
        <motion.div initial={{y: -20, opacity:0}} whileInView={{y:0, opacity: 1}} transition={{duration:0.5, delay: 0.5}}> 
        <h2 id="about" className="font-ovo text-5xl" style={{position:"relative", zIndex:10}} >About Me</h2>
        
          <div style={{position:"relative"}}></div>
          <div style={{position:"absolute", top:"0%", right:"-10%", zIndex:0, display:toggleProp? "block":"none", pointerEvents:"none"}}>
          <img src={assets.theme_pattern} className="w-36" />      
          </div>
        </motion.div>
        </div>
        </VStack>
        </Center>

        <motion.div initial={{opacity:0}} whileInView={{opacity: 1}} transition={{duration:0.8}} className={`flex w-full flex-col lg:flex-row items-center ${nextHub? "gap-10":"gap-20"} `}>
        <motion.div initial={{opacity:0, scale:0.9}} whileInView={{scale:1, opacity: 1}} transition={{duration: 0.6}} className="w-64 sm:w-80 rounded-3xl max-w-none">
          <img src={BenAuth} alt="Ben Asenso" className="w-full rounded-3xl" />
        </motion.div>
        
        <Box className="flex-1">
          <motion.div  initial={{opacity:0}} whileInView={{opacity: 1}} transition={{duration: 0.8, delay:1}}>
        <Text fontSize="xl" fontWeight="bold" style={{margin: "5px 5px 20px 5px", paddingTop: 20}}>I'm passionate about crafting immersive digital experiences that captivates audiences
        and drive meaningful engagement. With a blend of creativity, technical expertise and a relentless pursuit of innovation, I thrive on pushing the boundaries 
        of what's possible in the ever-evolving world of web development.
        </Text>

        <motion.div initial={{opacity:0}} whileInView={{opacity: 1}} transition={{duration: 0.8, delay:1}}>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl  mt-10">
        {infoList.map((f, index)=>{
          return <motion.div key={index} whileHover={{scale: 1.05}} className={`border-[0.5px] ${toggleProp? "border-white":"border-gray-400"} rounded-xl p-6 cursor-pointer ${toggleProp? "hover:bg-[#11002f]":"hover:bg-[#fcf4ff]"} hover:-translate-y-1 duration-500 
           ${toggleProp? "hover:shadow-[4px_4px_0_#fff]":"hover:shadow-[4px_4px_0_#000]"} `}>
            <Image src={toggleProp? f.iconDark:f.icon} alt={f.title} className="w-7 mt-3"/>
            <h3 className={`my-4 font-semibold ${toggleProp? "text-white":"text-gray-700"}`}>{f.title}</h3>
            <p className={`text-sm ${toggleProp? "text-white/80":"text-gray-600"}`}>{f.description}</p>
          </motion.div>
        })}
        </div>
        </motion.div>

        <motion.h4 initial={{y:20, opacity:0}} whileInView={{y:0, opacity:1}} transition={{duration: 0.5, delay:1.3}} className={`my-6 ${toggleProp? "text-white/80":"text-gray-700"}`}>Tools I use</motion.h4>
        <motion.div  initial={{opacity:0}} whileInView={{opacity: 1}} transition={{duration: 1.5, delay: 0.6}} className="flex items-center gap-3 sm:gap-5">
          {toolsData.map((f, index)=>{
            return <motion.div key={index} whileHover={{scale:1.05}} className="flex items-center justify-center w-12 sm:w-14 aspect-square border-[0.5px] border-gray-400 
            rounded-lg cursor-pointer hover:-translate-y-1 duration-500">
              <img src={f} alt="Tool" className="w-5 sm:w-7"/>
            </motion.div>
          })}
        </motion.div>
        </motion.div>
        </Box>
        </motion.div>

        <VStack>
          <Text className="mb-10" color={toggleProp? "white": "gray.700"} fontSize="lg" >
          Fuelled by curiosity for emerging technologies and a commitment to excellence, I'm constantly honing my skills to stay ahead of the curve.
          Whether it's mastering the latest frameworks, delving into data analysis or refining my design aesthetic, I approach every project with enthusiasm and a thirst
          for knowledge.
          But beyond the code, I'm a firm believer in the power of collaboration and communication. I understand that great digital experiences are not just about pixels and
          lines of code, they're about connecting with audiences on a deeper level, understanding their needs and delivering solutions that resonate. <br/><br/>
          When I'm not crafting code or brainstrorming the next big idea, you'll find me exploring the great outdoors, indulging in a good book or seeking inspiration from art and culture.
          I believe that a well-rounded perspective enriches my work and fuels my creativity.
          If you're looking to build a stunning website, optimize your digital presence or embark on a transformative digital journey, I'm here to bring your vision to life. Let's collaborate, innovate and create something extraordinary together.
          </Text>
        </VStack>

        
        <SimpleGrid gridTemplateColumns="repeat(2, 1fr)" gap={10}>

        <div className="about-skills">
          <div className="skill">
            <p>HTML & CSS</p><Divider className="line" style={{width:"50%",background: !toggleProp? "linear-gradient(264deg, #374151 -5.09%, #000 106.28%)":""}} />
          </div>
          <div className="skill">
            <p>React JS</p><Divider className="line" style={{width:"70%",background: !toggleProp? "linear-gradient(264deg, #374151 -5.09%, #000 106.28%)":""}} />
          </div>
          <div className="skill">
            <p>JavaScript</p><Divider className="line" style={{width:"60%",background: !toggleProp? "linear-gradient(264deg, #374151 -5.09%, #000 106.28%)":""}} />
          </div>
          <div className="skill">
            <p>Django</p><Divider className="line" style={{width:"50%",background: !toggleProp? "linear-gradient(264deg, #374151 -5.09%, #000 106.28%)":""}} />
          </div>

        </div>

        <div className="about-achievements">
          <div className="achieve">
            <h1 style={{backgroundImage:!toggleProp&& "linear-gradient(270deg, #374151 50.41%, #000 90.25%)", backgroundClip:!toggleProp&&"text"}}>4+</h1>  {/*10+ */} 
            <p className="text-center">YEARS OF EXPERIENCE</p>
          </div>
          <Divider bg={!toggleProp&&"black"} style={{transform:"rotate(90deg)", width:"10%"}}  />
          <div className="achieve">
            <h1 style={{backgroundImage:!toggleProp&& "linear-gradient(270deg, #374151 50.41%, #000 90.25%)", backgroundClip:!toggleProp&&"text"}}>90+</h1>
            <p className="text-center">PROJECTS COMPLETED</p>
          </div>
          <Divider bg={!toggleProp&&"black"} style={{transform:"rotate(90deg)", width:"10%"}}  />
          <div className="achieve">
            <h1 style={{backgroundImage:!toggleProp&& "linear-gradient(270deg, #374151 50.41%, #000 90.25%)", backgroundClip:!toggleProp&&"text"}}>15+</h1>
            <p className="text-center">HAPPY CLIENTS</p>
          </div>


        </div>
        </SimpleGrid>
        


        <Center>
          <VStack>
            <Popover
            isOpen={info}
            onClose={onClose}
            arrowSize={15}
            size="md"
            >
              <PopoverTrigger>
              <IconButton as={IconB} onClick={(e)=> setInfo(true)} children={<FontAwesomeIcon icon={faInfoCircle} size="2xl" />} isRound size="sm" /> 
              </PopoverTrigger>

              <PopoverContent bgColor="purple">
              <PopoverArrow  bgColor="purple" />
                <PopoverBody color="white" align="center" fontSize="lg" p={4} >
                References and Certification papers can be provided upon request. 
                For authenticity purposes only.
                </PopoverBody>
              </PopoverContent>
            </Popover>

        <Heading mt={5} >Qualifications</Heading>        
        </VStack>

        </Center>

        <Center>
        <HStack width={"100%"} justifyContent="space-between">
          <VStack>
           <animated.div style={animation}>
           <Image src={digital} loading="lazy" boxSize={tabletView? "60px": "100px"} />
          </animated.div>
          <Text align="center" fontSize={tabletView? "sm": "xl"} fontWeight="bold" style={{margin: 5, paddingTop: 20}}>
            Certified Digital<br/> Marketer by Google
          </Text>
          </VStack>

          <VStack>
          <animated.div style={animation2}>
          <Image src={hubspot} loading="lazy" width={tabletView? 20:40} />
          </animated.div>
          <Text align="center" fontSize={tabletView? "sm": "xl"}  fontWeight="bold" style={{margin: 5, paddingTop: 20}}>
            HubSpot Certified
          </Text>
          </VStack>

          <VStack>
          <animated.div style={animation}>
          <Image src={BIDA} boxSize={tabletView? "80px": "120px"} />
          </animated.div>

          <Text align="center" loading="lazy" fontSize={tabletView? "sm": "xl"}  fontWeight="bold" style={{margin: 5, paddingTop: 20}}>
            BIDA Certified
          </Text>
          </VStack>

          <VStack>
          <animated.div style={animation2}>
          <Image src={CMSA} loading="lazy" boxSize={tabletView? "80px": "120px"} />
          </animated.div>
          <Text align="center" fontSize={tabletView? "sm": "xl"} fontWeight="bold" style={{margin: 5, paddingTop: 20}}>
            CMSA Certified
          </Text>
          </VStack>

          <VStack>
          <animated.div style={animation}>
          <Image src={CBCA} boxSize={tabletView? "80px": "120px"} />
          </animated.div>
          <Text align="center" loading="lazy" fontSize={tabletView? "sm": "xl"} fontWeight="bold" style={{margin: 5, paddingTop: 20}}>
            CBCA Certified
          </Text>
          </VStack>

          <VStack>
          <animated.div style={animation2}>
          <Image src={experience} loading="lazy" boxSize={tabletView? "60px": "100px"} />
          </animated.div>
          <Text align="center" fontSize={tabletView? "sm": "xl"} fontWeight="bold" style={{margin: 5, paddingTop: 20}}>
            Years of Relevant Work<br/> Experience
          </Text>
          </VStack>

        </HStack>

        </Center>

  

        <Heading mt={5} textAlign="center">Industries</Heading>        

        <Center paddingBottom={10}>
               
          <HStack width={tabletView? "100%": (nextHub? "70%": "55%")} justifyContent="space-between">
            <VStack>
            <Avatar src={blockchain} loading="lazy" name="Blockchain" borderWidth={2} _hover={{transform: "scale(1.2)", transition: "transform 0.3s ease-in-out"}} filter={!color && "grayscale(100%)"} boxSize="120px" onMouseEnter={(e)=> setColor(true)} onMouseLeave={(e)=> setColor(false)}/>
            <Text fontSize="xl" fontWeight="bold" style={{margin: 5, paddingTop: 20}}>
            Blockchain
            </Text>
            </VStack>

            <VStack>
            <Avatar src={estate} name="Real Estate" loading="lazy" borderWidth={2} _hover={{transform: "scale(1.2)", transition: "transform 0.3s ease-in-out"}} filter={!color2 && "grayscale(100%)"} boxSize="120px" onMouseEnter={(e)=> setColor2(true)} onMouseLeave={(e)=> setColor2(false)} />
            <Text fontSize="xl" fontWeight="bold" style={{margin: 5, paddingTop: 20}}>
            Real Estate
            </Text>
            </VStack>

            <VStack>
            <Avatar src={financial} name="financial" loading="lazy" borderWidth={2} _hover={{transform: "scale(1.2)", transition: "transform 0.3s ease-in-out"}} filter={!color3 && "grayscale(100%)"} boxSize="120px" onMouseEnter={(e)=> setColor3(true)} onMouseLeave={(e)=> setColor3(false)} />
            <Text fontSize="xl" fontWeight="bold" style={{margin: 5, paddingTop: 20}}>
            Financial Services
            </Text>
            </VStack>

            <VStack>
            <Avatar src={retail} name="retail" loading="lazy" borderWidth={2} _hover={{transform: "scale(1.2)", transition: "transform 0.3s ease-in-out"}} filter={!color4 && "grayscale(100%)"} boxSize="120px" onMouseEnter={(e)=> setColor4(true)} onMouseLeave={(e)=> setColor4(false)}/>
            <Text fontSize="xl" fontWeight="bold" style={{margin: 5, paddingTop: 20}}>
            Retail
            </Text>
            </VStack>

    
          </HStack>
   
        </Center>





        </VStack>    
      </motion.div>
    </div>
  )
}

}


export default About;
